<div class="login-container">
  <div class="login-box">
    <div class="mb-2">
      <img
        src="assets/logos/sovos.colored.svg"
        alt="Sovos Watch"
        width="150"
        class="m-auto"
      />
    </div>

    <div>
      <form [formGroup]="loginForm" (submit)="login()">
        <h1 class="tw-text-lg tw-font-semibold mb-3 text-center">Welcome back!</h1>

        <label>Email Address</label>
        <input
          required
          type="email"
          class="form-control"
          placeholder="name@example.com"
          formControlName="email"
          required
        />

        <label>Password</label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          placeholder="Password"
          required
        />

        <button [disabled]="loginForm.invalid" class="btn btn-primary full">
          Log In
        </button>
      </form>
    </div>
  </div>
</div>
